// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `label {
  /* display: block; */
  margin-top: 10px;
}

.card-container.card {
  max-width: 350px !important;
  padding: 40px 40px;
}

.card {
  background-color: #f7f7f7;
  padding: 20px 25px 30px;
  margin: 0 auto 25px;
  margin-top: 50px;
  border-radius: 2px;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
}

.profile-img-card {
  width: 96px;
  height: 96px;
  margin: 0 auto 10px;
  display: block;
  border-radius: 50%;
}



.news-ticker {
  background-color: #fa6565;
  overflow: hidden;
  white-space: nowrap;
}

.news-text {
  display: inline-block;
  padding: 5px;
  font-size: 16px;
  font-weight: bold;
  color: #333;
  animation: scroll 10s linear infinite;
}

.news-ticker:hover .news-text {
  animation-play-state: paused; /* Pauses animation on hover */
}

@keyframes scroll {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(-100%);
  }
}




@media print {
  .navbar {
    display: none;
  }
  table {
    width: 100%; /* Make the table span the full width of the printed page */
    margin: 0 auto; /* Center the table horizontally */
    text-align: center; /* Center the text within the table cells */
  }
}

@media print {
  .sidebar {
    display: none; /* Hide the sidebar */
  }

  .content {
    margin-left: 0; /* Remove any left margin that was applied to account for the sidebar */
    padding: 20px; /* Add some padding for better readability */
  }

  /* Adjust other styles as needed for print */
}




/* === removing default button style ===*/
.button {
  margin: 0;
  height: auto;
  background: transparent;
  padding: 0;
  border: none;
  cursor: pointer;
}

/* button styling */
.button {
  --border-right: 2px;
  --text-stroke-color: rgba(255,255,255,0.6);
  --animation-color: #37FF8B;
  --fs-size: -1em;
  letter-spacing: 1px;
  text-decoration: none;
  font-size: var(--fs-size);
  font-family: "Arial";
  position: relative;
  text-transform: uppercase;
  color: transparent;
  -webkit-text-stroke: 1px var(--text-stroke-color);
}
/* this is the text, when you hover on button */
.hover-text {
  position: absolute;
  box-sizing: border-box;
  content: attr(data-text);
  color: var(--animation-color);
  width: 0%;
  inset: 0;
  border-right: var(--border-right) solid var(--animation-color);
  overflow: hidden;
  transition: 0.5s;
  -webkit-text-stroke: 1px var(--animation-color);
}
/* hover */
.button:hover .hover-text {
  width: 100%;
  filter: drop-shadow(0 0 23px var(--animation-color))
}



.loader {
  --duration: 3s;
  --primary: rgba(39, 94, 254, 1);
  --primary-light: #2f71ff;
  --primary-rgba: rgba(39, 94, 254, 0);
  width: 200px;
  height: 320px;
  position: relative;
  transform-style: preserve-3d;
}

@media (max-width: 480px) {
  .loader {
    zoom: 0.44;
  }
}

.loader:before, .loader:after {
  --r: 20.5deg;
  content: "";
  width: 320px;
  height: 140px;
  position: absolute;
  right: 32%;
  bottom: -11px;
/* change the back groung color on switching from light to dark mood */
  background: #e8e8e8;
  transform: translateZ(200px) rotate(var(--r));
  animation: mask var(--duration) linear forwards infinite;
}

.loader:after {
  --r: -20.5deg;
  right: auto;
  left: 32%;
}

.loader .ground {
  position: absolute;
  left: -50px;
  bottom: -120px;
  transform-style: preserve-3d;
  transform: rotateY(-47deg) rotateX(-15deg) rotateZ(15deg) scale(1);
}

.loader .ground div {
  transform: rotateX(90deg) rotateY(0deg) translate(-48px, -120px) translateZ(100px) scale(0);
  width: 200px;
  height: 200px;
  background: var(--primary);
  background: linear-gradient(45deg, var(--primary) 0%, var(--primary) 50%, var(--primary-light) 50%, var(--primary-light) 100%);
  transform-style: preserve-3d;
  animation: ground var(--duration) linear forwards infinite;
}

.loader .ground div:before, .loader .ground div:after {
  --rx: 90deg;
  --ry: 0deg;
  --x: 44px;
  --y: 162px;
  --z: -50px;
  content: "";
  width: 156px;
  height: 300px;
  opacity: 0;
  background: linear-gradient(var(--primary), var(--primary-rgba));
  position: absolute;
  transform: rotateX(var(--rx)) rotateY(var(--ry)) translate(var(--x), var(--y)) translateZ(var(--z));
  animation: ground-shine var(--duration) linear forwards infinite;
}

.loader .ground div:after {
  --rx: 90deg;
  --ry: 90deg;
  --x: 0;
  --y: 177px;
  --z: 150px;
}

.loader .box {
  --x: 0;
  --y: 0;
  position: absolute;
  animation: var(--duration) linear forwards infinite;
  transform: translate(var(--x), var(--y));
}

.loader .box div {
  background-color: var(--primary);
  width: 48px;
  height: 48px;
  position: relative;
  transform-style: preserve-3d;
  animation: var(--duration) ease forwards infinite;
  transform: rotateY(-47deg) rotateX(-15deg) rotateZ(15deg) scale(0);
}

.loader .box div:before, .loader .box div:after {
  --rx: 90deg;
  --ry: 0deg;
  --z: 24px;
  --y: -24px;
  --x: 0;
  content: "";
  position: absolute;
  background-color: inherit;
  width: inherit;
  height: inherit;
  transform: rotateX(var(--rx)) rotateY(var(--ry)) translate(var(--x), var(--y)) translateZ(var(--z));
  filter: brightness(var(--b, 1.2));
}

.loader .box div:after {
  --rx: 0deg;
  --ry: 90deg;
  --x: 24px;
  --y: 0;
  --b: 1.4;
}

.loader .box.box0 {
  --x: -220px;
  --y: -120px;
  left: 58px;
  top: 108px;
}

.loader .box.box1 {
  --x: -260px;
  --y: 120px;
  left: 25px;
  top: 120px;
}

.loader .box.box2 {
  --x: 120px;
  --y: -190px;
  left: 58px;
  top: 64px;
}

.loader .box.box3 {
  --x: 280px;
  --y: -40px;
  left: 91px;
  top: 120px;
}

.loader .box.box4 {
  --x: 60px;
  --y: 200px;
  left: 58px;
  top: 132px;
}

.loader .box.box5 {
  --x: -220px;
  --y: -120px;
  left: 25px;
  top: 76px;
}

.loader .box.box6 {
  --x: -260px;
  --y: 120px;
  left: 91px;
  top: 76px;
}

.loader .box.box7 {
  --x: -240px;
  --y: 200px;
  left: 58px;
  top: 87px;
}

.loader .box0 {
  animation-name: box-move0;
}

.loader .box0 div {
  animation-name: box-scale0;
}

.loader .box1 {
  animation-name: box-move1;
}

.loader .box1 div {
  animation-name: box-scale1;
}

.loader .box2 {
  animation-name: box-move2;
}

.loader .box2 div {
  animation-name: box-scale2;
}

.loader .box3 {
  animation-name: box-move3;
}

.loader .box3 div {
  animation-name: box-scale3;
}

.loader .box4 {
  animation-name: box-move4;
}

.loader .box4 div {
  animation-name: box-scale4;
}

.loader .box5 {
  animation-name: box-move5;
}

.loader .box5 div {
  animation-name: box-scale5;
}

.loader .box6 {
  animation-name: box-move6;
}

.loader .box6 div {
  animation-name: box-scale6;
}

.loader .box7 {
  animation-name: box-move7;
}

.loader .box7 div {
  animation-name: box-scale7;
}

@keyframes box-move0 {
  12% {
    transform: translate(var(--x), var(--y));
  }

  25%, 52% {
    transform: translate(0, 0);
  }

  80% {
    transform: translate(0, -32px);
  }

  90%, 100% {
    transform: translate(0, 188px);
  }
}

@keyframes box-scale0 {
  6% {
    transform: rotateY(-47deg) rotateX(-15deg) rotateZ(15deg) scale(0);
  }

  14%, 100% {
    transform: rotateY(-47deg) rotateX(-15deg) rotateZ(15deg) scale(1);
  }
}

@keyframes box-move1 {
  16% {
    transform: translate(var(--x), var(--y));
  }

  29%, 52% {
    transform: translate(0, 0);
  }

  80% {
    transform: translate(0, -32px);
  }

  90%, 100% {
    transform: translate(0, 188px);
  }
}

@keyframes box-scale1 {
  10% {
    transform: rotateY(-47deg) rotateX(-15deg) rotateZ(15deg) scale(0);
  }

  18%, 100% {
    transform: rotateY(-47deg) rotateX(-15deg) rotateZ(15deg) scale(1);
  }
}

@keyframes box-move2 {
  20% {
    transform: translate(var(--x), var(--y));
  }

  33%, 52% {
    transform: translate(0, 0);
  }

  80% {
    transform: translate(0, -32px);
  }

  90%, 100% {
    transform: translate(0, 188px);
  }
}

@keyframes box-scale2 {
  14% {
    transform: rotateY(-47deg) rotateX(-15deg) rotateZ(15deg) scale(0);
  }

  22%, 100% {
    transform: rotateY(-47deg) rotateX(-15deg) rotateZ(15deg) scale(1);
  }
}

@keyframes box-move3 {
  24% {
    transform: translate(var(--x), var(--y));
  }

  37%, 52% {
    transform: translate(0, 0);
  }

  80% {
    transform: translate(0, -32px);
  }

  90%, 100% {
    transform: translate(0, 188px);
  }
}

@keyframes box-scale3 {
  18% {
    transform: rotateY(-47deg) rotateX(-15deg) rotateZ(15deg) scale(0);
  }

  26%, 100% {
    transform: rotateY(-47deg) rotateX(-15deg) rotateZ(15deg) scale(1);
  }
}

@keyframes box-move4 {
  28% {
    transform: translate(var(--x), var(--y));
  }

  41%, 52% {
    transform: translate(0, 0);
  }

  80% {
    transform: translate(0, -32px);
  }

  90%, 100% {
    transform: translate(0, 188px);
  }
}

@keyframes box-scale4 {
  22% {
    transform: rotateY(-47deg) rotateX(-15deg) rotateZ(15deg) scale(0);
  }

  30%, 100% {
    transform: rotateY(-47deg) rotateX(-15deg) rotateZ(15deg) scale(1);
  }
}

@keyframes box-move5 {
  32% {
    transform: translate(var(--x), var(--y));
  }

  45%, 52% {
    transform: translate(0, 0);
  }

  80% {
    transform: translate(0, -32px);
  }

  90%, 100% {
    transform: translate(0, 188px);
  }
}

@keyframes box-scale5 {
  26% {
    transform: rotateY(-47deg) rotateX(-15deg) rotateZ(15deg) scale(0);
  }

  34%, 100% {
    transform: rotateY(-47deg) rotateX(-15deg) rotateZ(15deg) scale(1);
  }
}

@keyframes box-move6 {
  36% {
    transform: translate(var(--x), var(--y));
  }

  49%, 52% {
    transform: translate(0, 0);
  }

  80% {
    transform: translate(0, -32px);
  }

  90%, 100% {
    transform: translate(0, 188px);
  }
}

@keyframes box-scale6 {
  30% {
    transform: rotateY(-47deg) rotateX(-15deg) rotateZ(15deg) scale(0);
  }

  38%, 100% {
    transform: rotateY(-47deg) rotateX(-15deg) rotateZ(15deg) scale(1);
  }
}

@keyframes box-move7 {
  40% {
    transform: translate(var(--x), var(--y));
  }

  53%, 52% {
    transform: translate(0, 0);
  }

  80% {
    transform: translate(0, -32px);
  }

  90%, 100% {
    transform: translate(0, 188px);
  }
}

@keyframes box-scale7 {
  34% {
    transform: rotateY(-47deg) rotateX(-15deg) rotateZ(15deg) scale(0);
  }

  42%, 100% {
    transform: rotateY(-47deg) rotateX(-15deg) rotateZ(15deg) scale(1);
  }
}

@keyframes ground {
  0%, 65% {
    transform: rotateX(90deg) rotateY(0deg) translate(-48px, -120px) translateZ(100px) scale(0);
  }

  75%, 90% {
    transform: rotateX(90deg) rotateY(0deg) translate(-48px, -120px) translateZ(100px) scale(1);
  }

  100% {
    transform: rotateX(90deg) rotateY(0deg) translate(-48px, -120px) translateZ(100px) scale(0);
  }
}

@keyframes ground-shine {
  0%, 70% {
    opacity: 0;
  }

  75%, 87% {
    opacity: 0.2;
  }

  100% {
    opacity: 0;
  }
}

@keyframes mask {
  0%, 65% {
    opacity: 0;
  }

  66%, 100% {
    opacity: 1;
  }
}




















table {
  border-collapse: collapse;
  width: 50%;
  margin: 0 auto;
  border: '2px solid black' ;
}
th, td {
  border: 1px solid #dddddd;
  text-align: center;
  padding: 8px;
}
th {
  background-color: #f2f2f2;
}

/* record.css */

table {
border-collapse: collapse;
width: 100%;
margin: 0 auto;
}

th, td {
border: 1px solid #dddddd;
text-align: center;
padding: 8px;
}

th {
background-color: #f2f2f2;
}

/* Add this class to hide elements */
.hidden {
display: none;
}


.loading-central-circle {
width: 100px;
height: 100px;
border-radius: 50%;
position: relative;
margin: 0 auto;
animation: spin 1.5s linear infinite;
}

.loading-central-circle::before {
content: '';
display: block;
position: absolute;
width: 100%;
height: 100%;
border-radius: 50%;
border: 10px solid transparent;
border-top-color: #FF0000; /* Red */
border-bottom-color: #FFD700; /* Gold */
animation: spin 2s linear infinite reverse;
}

.loading-central-circle::after {
content: '';
display: block;
position: absolute;
width: 100%;
height: 100%;
border-radius: 50%;
border: 10px solid transparent;
border-top-color: #0aecb4; /* Gold */
border-bottom-color: #008000; /* Green */
animation: spin 3s linear infinite;
}

@keyframes spin {
0% { transform: rotate(0deg); }
100% { transform: rotate(360deg); }
}










/* Dropdown Button */
.dropbtn {
background-color: #4CAF50;
color: white;
padding: 16px;
font-size: 16px;
border: none;
}

/* The container <div> - needed to position the dropdown content */
.dropdown {
position: relative;
display: inline-block;
}

/* Dropdown Content (Hidden by Default) */
.dropdown-content {
display: none;
position: absolute;
background-color: #f1f1f1;
min-width: 160px;
box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
z-index: 1;
}

/* Show the dropdown menu on hover */
.dropdown:hover .dropdown-content {
display: block;
}




.table-scroll {
max-height: 600px; /* Adjust this height based on your requirement */
overflow-y: auto;
display: inline-block;
width: 100%;
}

.table-scroll thead th {
position: sticky;
top: 0;
background-color: #fff; /* Add a background color to the header */
box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.4); /* Optional: Add a shadow effect */
}



/* .app-container {
  display: flex;
  height: 100vh;
}

.sidebar {
  width: 200px;
  background-color: #333;
  color: #fff;
  transition: width 0.3s ease;
}

.sidebar ul {
  list-style-type: none;
  padding: 0;
}

.sidebar ul li {
  padding: 10px;
}

.content {
  flex: 1;
  padding: 20px;
}

.sidebar-toggle-btn {
  background: none;
  border: none;
  color: #fff;
  padding: 10px;
  cursor: pointer;
}

.app-container.toggled .sidebar {
  width: 0;
}
 */

 .sidebar {
  position: fixed;
  top: 0;
  left: 0;
  width: 250px; /* Adjust width as needed */
  height: 100vh; /* Set height to full viewport height */
  overflow-y: auto; /* Enable vertical scrolling */
  background-color: #333;
  color: #fff;
 

}

.content {
  margin-left: 250px; /* Adjust margin to accommodate sidebar width */
  /* Other content styling */
}

/* 
 .sidebar-item {
  
} */

.sidebar-item:hover,
.sidebar-item:focus {
  background-color: #6cc3e6; /* Change background color on hover */
}

.sidebar-item.active {
  background-color: #19a2fd; /* Change background color on click */
}





/* .app-container {
  position: relative;
} */
/* 
.sidebar {
  position: fixed;
  top: 0;
  left: 0;
  width: 250px;
  height: 100%;
  background-color: #333;
  color: #fff;
  transition: all 0.3s ease;
  z-index: 1000; 
} */

/* .sidebar.toggled {
  transform: translateX(-250px);
} */
/* 
.content {
  margin-left: 250px; 
} */

`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAGhB,kBAAkB;EAGlB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EAGd,kBAAkB;AACpB;;;;AAIA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,qCAAqC;AACvC;;AAEA;EACE,4BAA4B,EAAE,8BAA8B;AAC9D;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;AACF;;;;;AAKA;EACE;IACE,aAAa;EACf;EACA;IACE,WAAW,EAAE,2DAA2D;IACxE,cAAc,EAAE,kCAAkC;IAClD,kBAAkB,EAAE,2CAA2C;EACjE;AACF;;AAEA;EACE;IACE,aAAa,EAAE,qBAAqB;EACtC;;EAEA;IACE,cAAc,EAAE,uEAAuE;IACvF,aAAa,EAAE,4CAA4C;EAC7D;;EAEA,4CAA4C;AAC9C;;;;;AAKA,yCAAyC;AACzC;EACE,SAAS;EACT,YAAY;EACZ,uBAAuB;EACvB,UAAU;EACV,YAAY;EACZ,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,0BAA0B;EAC1B,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,oBAAoB;EACpB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,iDAAiD;AACnD;AACA,+CAA+C;AAC/C;EACE,kBAAkB;EAClB,sBAAsB;EACtB,wBAAwB;EACxB,6BAA6B;EAC7B,SAAS;EACT,QAAQ;EACR,8DAA8D;EAC9D,gBAAgB;EAChB,gBAAgB;EAChB,+CAA+C;AACjD;AACA,UAAU;AACV;EACE,WAAW;EACX;AACF;;;;AAIA;EACE,cAAc;EACd,+BAA+B;EAC/B,wBAAwB;EACxB,oCAAoC;EACpC,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,aAAa;AACf,sEAAsE;EACpE,mBAAmB;EACnB,6CAA6C;EAE7C,wDAAwD;AAC1D;;AAEA;EACE,aAAa;EACb,WAAW;EACX,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,4BAA4B;EAC5B,kEAAkE;AACpE;;AAEA;EACE,2FAA2F;EAC3F,YAAY;EACZ,aAAa;EACb,0BAA0B;EAC1B,8HAA8H;EAC9H,4BAA4B;EAE5B,0DAA0D;AAC5D;;AAEA;EACE,WAAW;EACX,UAAU;EACV,SAAS;EACT,UAAU;EACV,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,UAAU;EACV,gEAAgE;EAChE,kBAAkB;EAClB,mGAAmG;EAEnG,gEAAgE;AAClE;;AAEA;EACE,WAAW;EACX,WAAW;EACX,MAAM;EACN,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,MAAM;EACN,MAAM;EACN,kBAAkB;EAElB,mDAAmD;EACnD,wCAAwC;AAC1C;;AAEA;EACE,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;EAE5B,iDAAiD;EACjD,kEAAkE;AACpE;;AAEA;EACE,WAAW;EACX,UAAU;EACV,SAAS;EACT,UAAU;EACV,MAAM;EACN,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,mGAAmG;EACnG,iCAAiC;AACnC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,SAAS;EACT,MAAM;EACN,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,WAAW;EACX,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,UAAU;EACV,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,WAAW;EACX,UAAU;EACV,SAAS;AACX;;AAEA;EACE,UAAU;EACV,UAAU;EACV,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,UAAU;EACV,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,WAAW;EACX,UAAU;EACV,SAAS;AACX;;AAEA;EACE,WAAW;EACX,UAAU;EACV,UAAU;EACV,SAAS;AACX;;AAEA;EACE,WAAW;EACX,UAAU;EACV,UAAU;EACV,SAAS;AACX;;AAEA;EAEE,yBAAyB;AAC3B;;AAEA;EAEE,0BAA0B;AAC5B;;AAEA;EAEE,yBAAyB;AAC3B;;AAEA;EAEE,0BAA0B;AAC5B;;AAEA;EAEE,yBAAyB;AAC3B;;AAEA;EAEE,0BAA0B;AAC5B;;AAEA;EAEE,yBAAyB;AAC3B;;AAEA;EAEE,0BAA0B;AAC5B;;AAEA;EAEE,yBAAyB;AAC3B;;AAEA;EAEE,0BAA0B;AAC5B;;AAEA;EAEE,yBAAyB;AAC3B;;AAEA;EAEE,0BAA0B;AAC5B;;AAEA;EAEE,yBAAyB;AAC3B;;AAEA;EAEE,0BAA0B;AAC5B;;AAEA;EAEE,yBAAyB;AAC3B;;AAEA;EAEE,0BAA0B;AAC5B;;AAoBA;EACE;IACE,wCAAwC;EAC1C;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;EAChC;AACF;;AAYA;EACE;IACE,kEAAkE;EACpE;;EAEA;IACE,kEAAkE;EACpE;AACF;;AAoBA;EACE;IACE,wCAAwC;EAC1C;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;EAChC;AACF;;AAYA;EACE;IACE,kEAAkE;EACpE;;EAEA;IACE,kEAAkE;EACpE;AACF;;AAoBA;EACE;IACE,wCAAwC;EAC1C;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;EAChC;AACF;;AAYA;EACE;IACE,kEAAkE;EACpE;;EAEA;IACE,kEAAkE;EACpE;AACF;;AAoBA;EACE;IACE,wCAAwC;EAC1C;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;EAChC;AACF;;AAYA;EACE;IACE,kEAAkE;EACpE;;EAEA;IACE,kEAAkE;EACpE;AACF;;AAoBA;EACE;IACE,wCAAwC;EAC1C;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;EAChC;AACF;;AAYA;EACE;IACE,kEAAkE;EACpE;;EAEA;IACE,kEAAkE;EACpE;AACF;;AAoBA;EACE;IACE,wCAAwC;EAC1C;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;EAChC;AACF;;AAYA;EACE;IACE,kEAAkE;EACpE;;EAEA;IACE,kEAAkE;EACpE;AACF;;AAoBA;EACE;IACE,wCAAwC;EAC1C;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;EAChC;AACF;;AAYA;EACE;IACE,kEAAkE;EACpE;;EAEA;IACE,kEAAkE;EACpE;AACF;;AAoBA;EACE;IACE,wCAAwC;EAC1C;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;EAChC;AACF;;AAYA;EACE;IACE,kEAAkE;EACpE;;EAEA;IACE,kEAAkE;EACpE;AACF;;AAgBA;EACE;IACE,2FAA2F;EAC7F;;EAEA;IACE,2FAA2F;EAC7F;;EAEA;IACE,2FAA2F;EAC7F;AACF;;AAgBA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,UAAU;EACZ;AACF;;AAYA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;;;;;;;;;;;;;;;;;;;;AAqBA;EACE,yBAAyB;EACzB,UAAU;EACV,cAAc;EACd,0BAA0B;AAC5B;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;;AAEA,eAAe;;AAEf;AACA,yBAAyB;AACzB,WAAW;AACX,cAAc;AACd;;AAEA;AACA,yBAAyB;AACzB,kBAAkB;AAClB,YAAY;AACZ;;AAEA;AACA,yBAAyB;AACzB;;AAEA,oCAAoC;AACpC;AACA,aAAa;AACb;;;AAGA;AACA,YAAY;AACZ,aAAa;AACb,kBAAkB;AAClB,kBAAkB;AAClB,cAAc;AACd,oCAAoC;AACpC;;AAEA;AACA,WAAW;AACX,cAAc;AACd,kBAAkB;AAClB,WAAW;AACX,YAAY;AACZ,kBAAkB;AAClB,8BAA8B;AAC9B,yBAAyB,EAAE,QAAQ;AACnC,4BAA4B,EAAE,SAAS;AACvC,0CAA0C;AAC1C;;AAEA;AACA,WAAW;AACX,cAAc;AACd,kBAAkB;AAClB,WAAW;AACX,YAAY;AACZ,kBAAkB;AAClB,8BAA8B;AAC9B,yBAAyB,EAAE,SAAS;AACpC,4BAA4B,EAAE,UAAU;AACxC,kCAAkC;AAClC;;AAEA;AACA,KAAK,uBAAuB,EAAE;AAC9B,OAAO,yBAAyB,EAAE;AAClC;;;;;;;;;;;AAWA,oBAAoB;AACpB;AACA,yBAAyB;AACzB,YAAY;AACZ,aAAa;AACb,eAAe;AACf,YAAY;AACZ;;AAEA,kEAAkE;AAClE;AACA,kBAAkB;AAClB,qBAAqB;AACrB;;AAEA,yCAAyC;AACzC;AACA,aAAa;AACb,kBAAkB;AAClB,yBAAyB;AACzB,gBAAgB;AAChB,4CAA4C;AAC5C,UAAU;AACV;;AAEA,oCAAoC;AACpC;AACA,cAAc;AACd;;;;;AAKA;AACA,iBAAiB,EAAE,iDAAiD;AACpE,gBAAgB;AAChB,qBAAqB;AACrB,WAAW;AACX;;AAEA;AACA,gBAAgB;AAChB,MAAM;AACN,sBAAsB,EAAE,yCAAyC;AACjE,6CAA6C,EAAE,kCAAkC;AACjF;;;;AAIA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAqCE;;CAED;EACC,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY,EAAE,2BAA2B;EACzC,aAAa,EAAE,uCAAuC;EACtD,gBAAgB,EAAE,8BAA8B;EAChD,sBAAsB;EACtB,WAAW;;;AAGb;;AAEA;EACE,kBAAkB,EAAE,+CAA+C;EACnE,0BAA0B;AAC5B;;AAEA;;;GAGG;;AAEH;;EAEE,yBAAyB,EAAE,qCAAqC;AAClE;;AAEA;EACE,yBAAyB,EAAE,qCAAqC;AAClE;;;;;;AAMA;;GAEG;AACH;;;;;;;;;;;GAWG;;AAEH;;GAEG;AACH;;;GAGG","sourcesContent":["label {\n  /* display: block; */\n  margin-top: 10px;\n}\n\n.card-container.card {\n  max-width: 350px !important;\n  padding: 40px 40px;\n}\n\n.card {\n  background-color: #f7f7f7;\n  padding: 20px 25px 30px;\n  margin: 0 auto 25px;\n  margin-top: 50px;\n  -moz-border-radius: 2px;\n  -webkit-border-radius: 2px;\n  border-radius: 2px;\n  -moz-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);\n  -webkit-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);\n  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);\n}\n\n.profile-img-card {\n  width: 96px;\n  height: 96px;\n  margin: 0 auto 10px;\n  display: block;\n  -moz-border-radius: 50%;\n  -webkit-border-radius: 50%;\n  border-radius: 50%;\n}\n\n\n\n.news-ticker {\n  background-color: #fa6565;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n.news-text {\n  display: inline-block;\n  padding: 5px;\n  font-size: 16px;\n  font-weight: bold;\n  color: #333;\n  animation: scroll 10s linear infinite;\n}\n\n.news-ticker:hover .news-text {\n  animation-play-state: paused; /* Pauses animation on hover */\n}\n\n@keyframes scroll {\n  from {\n    transform: translateX(100%);\n  }\n  to {\n    transform: translateX(-100%);\n  }\n}\n\n\n\n\n@media print {\n  .navbar {\n    display: none;\n  }\n  table {\n    width: 100%; /* Make the table span the full width of the printed page */\n    margin: 0 auto; /* Center the table horizontally */\n    text-align: center; /* Center the text within the table cells */\n  }\n}\n\n@media print {\n  .sidebar {\n    display: none; /* Hide the sidebar */\n  }\n\n  .content {\n    margin-left: 0; /* Remove any left margin that was applied to account for the sidebar */\n    padding: 20px; /* Add some padding for better readability */\n  }\n\n  /* Adjust other styles as needed for print */\n}\n\n\n\n\n/* === removing default button style ===*/\n.button {\n  margin: 0;\n  height: auto;\n  background: transparent;\n  padding: 0;\n  border: none;\n  cursor: pointer;\n}\n\n/* button styling */\n.button {\n  --border-right: 2px;\n  --text-stroke-color: rgba(255,255,255,0.6);\n  --animation-color: #37FF8B;\n  --fs-size: -1em;\n  letter-spacing: 1px;\n  text-decoration: none;\n  font-size: var(--fs-size);\n  font-family: \"Arial\";\n  position: relative;\n  text-transform: uppercase;\n  color: transparent;\n  -webkit-text-stroke: 1px var(--text-stroke-color);\n}\n/* this is the text, when you hover on button */\n.hover-text {\n  position: absolute;\n  box-sizing: border-box;\n  content: attr(data-text);\n  color: var(--animation-color);\n  width: 0%;\n  inset: 0;\n  border-right: var(--border-right) solid var(--animation-color);\n  overflow: hidden;\n  transition: 0.5s;\n  -webkit-text-stroke: 1px var(--animation-color);\n}\n/* hover */\n.button:hover .hover-text {\n  width: 100%;\n  filter: drop-shadow(0 0 23px var(--animation-color))\n}\n\n\n\n.loader {\n  --duration: 3s;\n  --primary: rgba(39, 94, 254, 1);\n  --primary-light: #2f71ff;\n  --primary-rgba: rgba(39, 94, 254, 0);\n  width: 200px;\n  height: 320px;\n  position: relative;\n  transform-style: preserve-3d;\n}\n\n@media (max-width: 480px) {\n  .loader {\n    zoom: 0.44;\n  }\n}\n\n.loader:before, .loader:after {\n  --r: 20.5deg;\n  content: \"\";\n  width: 320px;\n  height: 140px;\n  position: absolute;\n  right: 32%;\n  bottom: -11px;\n/* change the back groung color on switching from light to dark mood */\n  background: #e8e8e8;\n  transform: translateZ(200px) rotate(var(--r));\n  -webkit-animation: mask var(--duration) linear forwards infinite;\n  animation: mask var(--duration) linear forwards infinite;\n}\n\n.loader:after {\n  --r: -20.5deg;\n  right: auto;\n  left: 32%;\n}\n\n.loader .ground {\n  position: absolute;\n  left: -50px;\n  bottom: -120px;\n  transform-style: preserve-3d;\n  transform: rotateY(-47deg) rotateX(-15deg) rotateZ(15deg) scale(1);\n}\n\n.loader .ground div {\n  transform: rotateX(90deg) rotateY(0deg) translate(-48px, -120px) translateZ(100px) scale(0);\n  width: 200px;\n  height: 200px;\n  background: var(--primary);\n  background: linear-gradient(45deg, var(--primary) 0%, var(--primary) 50%, var(--primary-light) 50%, var(--primary-light) 100%);\n  transform-style: preserve-3d;\n  -webkit-animation: ground var(--duration) linear forwards infinite;\n  animation: ground var(--duration) linear forwards infinite;\n}\n\n.loader .ground div:before, .loader .ground div:after {\n  --rx: 90deg;\n  --ry: 0deg;\n  --x: 44px;\n  --y: 162px;\n  --z: -50px;\n  content: \"\";\n  width: 156px;\n  height: 300px;\n  opacity: 0;\n  background: linear-gradient(var(--primary), var(--primary-rgba));\n  position: absolute;\n  transform: rotateX(var(--rx)) rotateY(var(--ry)) translate(var(--x), var(--y)) translateZ(var(--z));\n  -webkit-animation: ground-shine var(--duration) linear forwards infinite;\n  animation: ground-shine var(--duration) linear forwards infinite;\n}\n\n.loader .ground div:after {\n  --rx: 90deg;\n  --ry: 90deg;\n  --x: 0;\n  --y: 177px;\n  --z: 150px;\n}\n\n.loader .box {\n  --x: 0;\n  --y: 0;\n  position: absolute;\n  -webkit-animation: var(--duration) linear forwards infinite;\n  animation: var(--duration) linear forwards infinite;\n  transform: translate(var(--x), var(--y));\n}\n\n.loader .box div {\n  background-color: var(--primary);\n  width: 48px;\n  height: 48px;\n  position: relative;\n  transform-style: preserve-3d;\n  -webkit-animation: var(--duration) ease forwards infinite;\n  animation: var(--duration) ease forwards infinite;\n  transform: rotateY(-47deg) rotateX(-15deg) rotateZ(15deg) scale(0);\n}\n\n.loader .box div:before, .loader .box div:after {\n  --rx: 90deg;\n  --ry: 0deg;\n  --z: 24px;\n  --y: -24px;\n  --x: 0;\n  content: \"\";\n  position: absolute;\n  background-color: inherit;\n  width: inherit;\n  height: inherit;\n  transform: rotateX(var(--rx)) rotateY(var(--ry)) translate(var(--x), var(--y)) translateZ(var(--z));\n  filter: brightness(var(--b, 1.2));\n}\n\n.loader .box div:after {\n  --rx: 0deg;\n  --ry: 90deg;\n  --x: 24px;\n  --y: 0;\n  --b: 1.4;\n}\n\n.loader .box.box0 {\n  --x: -220px;\n  --y: -120px;\n  left: 58px;\n  top: 108px;\n}\n\n.loader .box.box1 {\n  --x: -260px;\n  --y: 120px;\n  left: 25px;\n  top: 120px;\n}\n\n.loader .box.box2 {\n  --x: 120px;\n  --y: -190px;\n  left: 58px;\n  top: 64px;\n}\n\n.loader .box.box3 {\n  --x: 280px;\n  --y: -40px;\n  left: 91px;\n  top: 120px;\n}\n\n.loader .box.box4 {\n  --x: 60px;\n  --y: 200px;\n  left: 58px;\n  top: 132px;\n}\n\n.loader .box.box5 {\n  --x: -220px;\n  --y: -120px;\n  left: 25px;\n  top: 76px;\n}\n\n.loader .box.box6 {\n  --x: -260px;\n  --y: 120px;\n  left: 91px;\n  top: 76px;\n}\n\n.loader .box.box7 {\n  --x: -240px;\n  --y: 200px;\n  left: 58px;\n  top: 87px;\n}\n\n.loader .box0 {\n  -webkit-animation-name: box-move0;\n  animation-name: box-move0;\n}\n\n.loader .box0 div {\n  -webkit-animation-name: box-scale0;\n  animation-name: box-scale0;\n}\n\n.loader .box1 {\n  -webkit-animation-name: box-move1;\n  animation-name: box-move1;\n}\n\n.loader .box1 div {\n  -webkit-animation-name: box-scale1;\n  animation-name: box-scale1;\n}\n\n.loader .box2 {\n  -webkit-animation-name: box-move2;\n  animation-name: box-move2;\n}\n\n.loader .box2 div {\n  -webkit-animation-name: box-scale2;\n  animation-name: box-scale2;\n}\n\n.loader .box3 {\n  -webkit-animation-name: box-move3;\n  animation-name: box-move3;\n}\n\n.loader .box3 div {\n  -webkit-animation-name: box-scale3;\n  animation-name: box-scale3;\n}\n\n.loader .box4 {\n  -webkit-animation-name: box-move4;\n  animation-name: box-move4;\n}\n\n.loader .box4 div {\n  -webkit-animation-name: box-scale4;\n  animation-name: box-scale4;\n}\n\n.loader .box5 {\n  -webkit-animation-name: box-move5;\n  animation-name: box-move5;\n}\n\n.loader .box5 div {\n  -webkit-animation-name: box-scale5;\n  animation-name: box-scale5;\n}\n\n.loader .box6 {\n  -webkit-animation-name: box-move6;\n  animation-name: box-move6;\n}\n\n.loader .box6 div {\n  -webkit-animation-name: box-scale6;\n  animation-name: box-scale6;\n}\n\n.loader .box7 {\n  -webkit-animation-name: box-move7;\n  animation-name: box-move7;\n}\n\n.loader .box7 div {\n  -webkit-animation-name: box-scale7;\n  animation-name: box-scale7;\n}\n\n@-webkit-keyframes box-move0 {\n  12% {\n    transform: translate(var(--x), var(--y));\n  }\n\n  25%, 52% {\n    transform: translate(0, 0);\n  }\n\n  80% {\n    transform: translate(0, -32px);\n  }\n\n  90%, 100% {\n    transform: translate(0, 188px);\n  }\n}\n\n@keyframes box-move0 {\n  12% {\n    transform: translate(var(--x), var(--y));\n  }\n\n  25%, 52% {\n    transform: translate(0, 0);\n  }\n\n  80% {\n    transform: translate(0, -32px);\n  }\n\n  90%, 100% {\n    transform: translate(0, 188px);\n  }\n}\n\n@-webkit-keyframes box-scale0 {\n  6% {\n    transform: rotateY(-47deg) rotateX(-15deg) rotateZ(15deg) scale(0);\n  }\n\n  14%, 100% {\n    transform: rotateY(-47deg) rotateX(-15deg) rotateZ(15deg) scale(1);\n  }\n}\n\n@keyframes box-scale0 {\n  6% {\n    transform: rotateY(-47deg) rotateX(-15deg) rotateZ(15deg) scale(0);\n  }\n\n  14%, 100% {\n    transform: rotateY(-47deg) rotateX(-15deg) rotateZ(15deg) scale(1);\n  }\n}\n\n@-webkit-keyframes box-move1 {\n  16% {\n    transform: translate(var(--x), var(--y));\n  }\n\n  29%, 52% {\n    transform: translate(0, 0);\n  }\n\n  80% {\n    transform: translate(0, -32px);\n  }\n\n  90%, 100% {\n    transform: translate(0, 188px);\n  }\n}\n\n@keyframes box-move1 {\n  16% {\n    transform: translate(var(--x), var(--y));\n  }\n\n  29%, 52% {\n    transform: translate(0, 0);\n  }\n\n  80% {\n    transform: translate(0, -32px);\n  }\n\n  90%, 100% {\n    transform: translate(0, 188px);\n  }\n}\n\n@-webkit-keyframes box-scale1 {\n  10% {\n    transform: rotateY(-47deg) rotateX(-15deg) rotateZ(15deg) scale(0);\n  }\n\n  18%, 100% {\n    transform: rotateY(-47deg) rotateX(-15deg) rotateZ(15deg) scale(1);\n  }\n}\n\n@keyframes box-scale1 {\n  10% {\n    transform: rotateY(-47deg) rotateX(-15deg) rotateZ(15deg) scale(0);\n  }\n\n  18%, 100% {\n    transform: rotateY(-47deg) rotateX(-15deg) rotateZ(15deg) scale(1);\n  }\n}\n\n@-webkit-keyframes box-move2 {\n  20% {\n    transform: translate(var(--x), var(--y));\n  }\n\n  33%, 52% {\n    transform: translate(0, 0);\n  }\n\n  80% {\n    transform: translate(0, -32px);\n  }\n\n  90%, 100% {\n    transform: translate(0, 188px);\n  }\n}\n\n@keyframes box-move2 {\n  20% {\n    transform: translate(var(--x), var(--y));\n  }\n\n  33%, 52% {\n    transform: translate(0, 0);\n  }\n\n  80% {\n    transform: translate(0, -32px);\n  }\n\n  90%, 100% {\n    transform: translate(0, 188px);\n  }\n}\n\n@-webkit-keyframes box-scale2 {\n  14% {\n    transform: rotateY(-47deg) rotateX(-15deg) rotateZ(15deg) scale(0);\n  }\n\n  22%, 100% {\n    transform: rotateY(-47deg) rotateX(-15deg) rotateZ(15deg) scale(1);\n  }\n}\n\n@keyframes box-scale2 {\n  14% {\n    transform: rotateY(-47deg) rotateX(-15deg) rotateZ(15deg) scale(0);\n  }\n\n  22%, 100% {\n    transform: rotateY(-47deg) rotateX(-15deg) rotateZ(15deg) scale(1);\n  }\n}\n\n@-webkit-keyframes box-move3 {\n  24% {\n    transform: translate(var(--x), var(--y));\n  }\n\n  37%, 52% {\n    transform: translate(0, 0);\n  }\n\n  80% {\n    transform: translate(0, -32px);\n  }\n\n  90%, 100% {\n    transform: translate(0, 188px);\n  }\n}\n\n@keyframes box-move3 {\n  24% {\n    transform: translate(var(--x), var(--y));\n  }\n\n  37%, 52% {\n    transform: translate(0, 0);\n  }\n\n  80% {\n    transform: translate(0, -32px);\n  }\n\n  90%, 100% {\n    transform: translate(0, 188px);\n  }\n}\n\n@-webkit-keyframes box-scale3 {\n  18% {\n    transform: rotateY(-47deg) rotateX(-15deg) rotateZ(15deg) scale(0);\n  }\n\n  26%, 100% {\n    transform: rotateY(-47deg) rotateX(-15deg) rotateZ(15deg) scale(1);\n  }\n}\n\n@keyframes box-scale3 {\n  18% {\n    transform: rotateY(-47deg) rotateX(-15deg) rotateZ(15deg) scale(0);\n  }\n\n  26%, 100% {\n    transform: rotateY(-47deg) rotateX(-15deg) rotateZ(15deg) scale(1);\n  }\n}\n\n@-webkit-keyframes box-move4 {\n  28% {\n    transform: translate(var(--x), var(--y));\n  }\n\n  41%, 52% {\n    transform: translate(0, 0);\n  }\n\n  80% {\n    transform: translate(0, -32px);\n  }\n\n  90%, 100% {\n    transform: translate(0, 188px);\n  }\n}\n\n@keyframes box-move4 {\n  28% {\n    transform: translate(var(--x), var(--y));\n  }\n\n  41%, 52% {\n    transform: translate(0, 0);\n  }\n\n  80% {\n    transform: translate(0, -32px);\n  }\n\n  90%, 100% {\n    transform: translate(0, 188px);\n  }\n}\n\n@-webkit-keyframes box-scale4 {\n  22% {\n    transform: rotateY(-47deg) rotateX(-15deg) rotateZ(15deg) scale(0);\n  }\n\n  30%, 100% {\n    transform: rotateY(-47deg) rotateX(-15deg) rotateZ(15deg) scale(1);\n  }\n}\n\n@keyframes box-scale4 {\n  22% {\n    transform: rotateY(-47deg) rotateX(-15deg) rotateZ(15deg) scale(0);\n  }\n\n  30%, 100% {\n    transform: rotateY(-47deg) rotateX(-15deg) rotateZ(15deg) scale(1);\n  }\n}\n\n@-webkit-keyframes box-move5 {\n  32% {\n    transform: translate(var(--x), var(--y));\n  }\n\n  45%, 52% {\n    transform: translate(0, 0);\n  }\n\n  80% {\n    transform: translate(0, -32px);\n  }\n\n  90%, 100% {\n    transform: translate(0, 188px);\n  }\n}\n\n@keyframes box-move5 {\n  32% {\n    transform: translate(var(--x), var(--y));\n  }\n\n  45%, 52% {\n    transform: translate(0, 0);\n  }\n\n  80% {\n    transform: translate(0, -32px);\n  }\n\n  90%, 100% {\n    transform: translate(0, 188px);\n  }\n}\n\n@-webkit-keyframes box-scale5 {\n  26% {\n    transform: rotateY(-47deg) rotateX(-15deg) rotateZ(15deg) scale(0);\n  }\n\n  34%, 100% {\n    transform: rotateY(-47deg) rotateX(-15deg) rotateZ(15deg) scale(1);\n  }\n}\n\n@keyframes box-scale5 {\n  26% {\n    transform: rotateY(-47deg) rotateX(-15deg) rotateZ(15deg) scale(0);\n  }\n\n  34%, 100% {\n    transform: rotateY(-47deg) rotateX(-15deg) rotateZ(15deg) scale(1);\n  }\n}\n\n@-webkit-keyframes box-move6 {\n  36% {\n    transform: translate(var(--x), var(--y));\n  }\n\n  49%, 52% {\n    transform: translate(0, 0);\n  }\n\n  80% {\n    transform: translate(0, -32px);\n  }\n\n  90%, 100% {\n    transform: translate(0, 188px);\n  }\n}\n\n@keyframes box-move6 {\n  36% {\n    transform: translate(var(--x), var(--y));\n  }\n\n  49%, 52% {\n    transform: translate(0, 0);\n  }\n\n  80% {\n    transform: translate(0, -32px);\n  }\n\n  90%, 100% {\n    transform: translate(0, 188px);\n  }\n}\n\n@-webkit-keyframes box-scale6 {\n  30% {\n    transform: rotateY(-47deg) rotateX(-15deg) rotateZ(15deg) scale(0);\n  }\n\n  38%, 100% {\n    transform: rotateY(-47deg) rotateX(-15deg) rotateZ(15deg) scale(1);\n  }\n}\n\n@keyframes box-scale6 {\n  30% {\n    transform: rotateY(-47deg) rotateX(-15deg) rotateZ(15deg) scale(0);\n  }\n\n  38%, 100% {\n    transform: rotateY(-47deg) rotateX(-15deg) rotateZ(15deg) scale(1);\n  }\n}\n\n@-webkit-keyframes box-move7 {\n  40% {\n    transform: translate(var(--x), var(--y));\n  }\n\n  53%, 52% {\n    transform: translate(0, 0);\n  }\n\n  80% {\n    transform: translate(0, -32px);\n  }\n\n  90%, 100% {\n    transform: translate(0, 188px);\n  }\n}\n\n@keyframes box-move7 {\n  40% {\n    transform: translate(var(--x), var(--y));\n  }\n\n  53%, 52% {\n    transform: translate(0, 0);\n  }\n\n  80% {\n    transform: translate(0, -32px);\n  }\n\n  90%, 100% {\n    transform: translate(0, 188px);\n  }\n}\n\n@-webkit-keyframes box-scale7 {\n  34% {\n    transform: rotateY(-47deg) rotateX(-15deg) rotateZ(15deg) scale(0);\n  }\n\n  42%, 100% {\n    transform: rotateY(-47deg) rotateX(-15deg) rotateZ(15deg) scale(1);\n  }\n}\n\n@keyframes box-scale7 {\n  34% {\n    transform: rotateY(-47deg) rotateX(-15deg) rotateZ(15deg) scale(0);\n  }\n\n  42%, 100% {\n    transform: rotateY(-47deg) rotateX(-15deg) rotateZ(15deg) scale(1);\n  }\n}\n\n@-webkit-keyframes ground {\n  0%, 65% {\n    transform: rotateX(90deg) rotateY(0deg) translate(-48px, -120px) translateZ(100px) scale(0);\n  }\n\n  75%, 90% {\n    transform: rotateX(90deg) rotateY(0deg) translate(-48px, -120px) translateZ(100px) scale(1);\n  }\n\n  100% {\n    transform: rotateX(90deg) rotateY(0deg) translate(-48px, -120px) translateZ(100px) scale(0);\n  }\n}\n\n@keyframes ground {\n  0%, 65% {\n    transform: rotateX(90deg) rotateY(0deg) translate(-48px, -120px) translateZ(100px) scale(0);\n  }\n\n  75%, 90% {\n    transform: rotateX(90deg) rotateY(0deg) translate(-48px, -120px) translateZ(100px) scale(1);\n  }\n\n  100% {\n    transform: rotateX(90deg) rotateY(0deg) translate(-48px, -120px) translateZ(100px) scale(0);\n  }\n}\n\n@-webkit-keyframes ground-shine {\n  0%, 70% {\n    opacity: 0;\n  }\n\n  75%, 87% {\n    opacity: 0.2;\n  }\n\n  100% {\n    opacity: 0;\n  }\n}\n\n@keyframes ground-shine {\n  0%, 70% {\n    opacity: 0;\n  }\n\n  75%, 87% {\n    opacity: 0.2;\n  }\n\n  100% {\n    opacity: 0;\n  }\n}\n\n@-webkit-keyframes mask {\n  0%, 65% {\n    opacity: 0;\n  }\n\n  66%, 100% {\n    opacity: 1;\n  }\n}\n\n@keyframes mask {\n  0%, 65% {\n    opacity: 0;\n  }\n\n  66%, 100% {\n    opacity: 1;\n  }\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\ntable {\n  border-collapse: collapse;\n  width: 50%;\n  margin: 0 auto;\n  border: '2px solid black' ;\n}\nth, td {\n  border: 1px solid #dddddd;\n  text-align: center;\n  padding: 8px;\n}\nth {\n  background-color: #f2f2f2;\n}\n\n/* record.css */\n\ntable {\nborder-collapse: collapse;\nwidth: 100%;\nmargin: 0 auto;\n}\n\nth, td {\nborder: 1px solid #dddddd;\ntext-align: center;\npadding: 8px;\n}\n\nth {\nbackground-color: #f2f2f2;\n}\n\n/* Add this class to hide elements */\n.hidden {\ndisplay: none;\n}\n\n\n.loading-central-circle {\nwidth: 100px;\nheight: 100px;\nborder-radius: 50%;\nposition: relative;\nmargin: 0 auto;\nanimation: spin 1.5s linear infinite;\n}\n\n.loading-central-circle::before {\ncontent: '';\ndisplay: block;\nposition: absolute;\nwidth: 100%;\nheight: 100%;\nborder-radius: 50%;\nborder: 10px solid transparent;\nborder-top-color: #FF0000; /* Red */\nborder-bottom-color: #FFD700; /* Gold */\nanimation: spin 2s linear infinite reverse;\n}\n\n.loading-central-circle::after {\ncontent: '';\ndisplay: block;\nposition: absolute;\nwidth: 100%;\nheight: 100%;\nborder-radius: 50%;\nborder: 10px solid transparent;\nborder-top-color: #0aecb4; /* Gold */\nborder-bottom-color: #008000; /* Green */\nanimation: spin 3s linear infinite;\n}\n\n@keyframes spin {\n0% { transform: rotate(0deg); }\n100% { transform: rotate(360deg); }\n}\n\n\n\n\n\n\n\n\n\n\n/* Dropdown Button */\n.dropbtn {\nbackground-color: #4CAF50;\ncolor: white;\npadding: 16px;\nfont-size: 16px;\nborder: none;\n}\n\n/* The container <div> - needed to position the dropdown content */\n.dropdown {\nposition: relative;\ndisplay: inline-block;\n}\n\n/* Dropdown Content (Hidden by Default) */\n.dropdown-content {\ndisplay: none;\nposition: absolute;\nbackground-color: #f1f1f1;\nmin-width: 160px;\nbox-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);\nz-index: 1;\n}\n\n/* Show the dropdown menu on hover */\n.dropdown:hover .dropdown-content {\ndisplay: block;\n}\n\n\n\n\n.table-scroll {\nmax-height: 600px; /* Adjust this height based on your requirement */\noverflow-y: auto;\ndisplay: inline-block;\nwidth: 100%;\n}\n\n.table-scroll thead th {\nposition: sticky;\ntop: 0;\nbackground-color: #fff; /* Add a background color to the header */\nbox-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.4); /* Optional: Add a shadow effect */\n}\n\n\n\n/* .app-container {\n  display: flex;\n  height: 100vh;\n}\n\n.sidebar {\n  width: 200px;\n  background-color: #333;\n  color: #fff;\n  transition: width 0.3s ease;\n}\n\n.sidebar ul {\n  list-style-type: none;\n  padding: 0;\n}\n\n.sidebar ul li {\n  padding: 10px;\n}\n\n.content {\n  flex: 1;\n  padding: 20px;\n}\n\n.sidebar-toggle-btn {\n  background: none;\n  border: none;\n  color: #fff;\n  padding: 10px;\n  cursor: pointer;\n}\n\n.app-container.toggled .sidebar {\n  width: 0;\n}\n */\n\n .sidebar {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 250px; /* Adjust width as needed */\n  height: 100vh; /* Set height to full viewport height */\n  overflow-y: auto; /* Enable vertical scrolling */\n  background-color: #333;\n  color: #fff;\n \n\n}\n\n.content {\n  margin-left: 250px; /* Adjust margin to accommodate sidebar width */\n  /* Other content styling */\n}\n\n/* \n .sidebar-item {\n  \n} */\n\n.sidebar-item:hover,\n.sidebar-item:focus {\n  background-color: #6cc3e6; /* Change background color on hover */\n}\n\n.sidebar-item.active {\n  background-color: #19a2fd; /* Change background color on click */\n}\n\n\n\n\n\n/* .app-container {\n  position: relative;\n} */\n/* \n.sidebar {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 250px;\n  height: 100%;\n  background-color: #333;\n  color: #fff;\n  transition: all 0.3s ease;\n  z-index: 1000; \n} */\n\n/* .sidebar.toggled {\n  transform: translateX(-250px);\n} */\n/* \n.content {\n  margin-left: 250px; \n} */\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
